const deps = ['Api'];
const factory = function (Api) {
  class BookkeepingApi extends Api {
    constructor() {
      super('benchBackend');
    }
  }

  return new BookkeepingApi();
};

factory.$inject = deps;
module.exports = factory;
